export const ZoomIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <circle cx="6.5" cy="6.5" r="6" stroke="#1e1e1e" />
      <line x1="3.5" y1="6.5" x2="9.5" y2="6.5" stroke="#1e1e1e" strokeLinecap="round" />
      <line x1="6.5" y1="3.5" x2="6.5" y2="9.5" stroke="#1e1e1e" strokeLinecap="round" />
      <line x1="10.7071" y1="10.9994" x2="13.0002" y2="13.2883" stroke="#1e1e1e" strokeLinecap="round" />
    </svg>
  );
};
